import { useState } from "react";
import { SECTIONS, sectionLabel } from "@/lib/sections";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Medal } from "lucide-react";
import SkillMemberCard from "@/components/SkillMemberCard";
import useSkills from "@/hooks/useSkills";

function AwardBanner({ section, award }) {
  if (!award) return null;
  return (
    <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-4 card-shadow-soft">
      <div className="w-10 h-10 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center"><Medal className="w-5 h-5" /></div>
      <div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">{sectionLabel(section)} award</div>
        <div className="font-bold" style={{ fontFamily: "Outfit" }} data-testid="award-name">{award.name}</div>
      </div>
    </div>
  );
}

export default function Skills() {
  const [section, setSection] = useState("scouts");
  const { members, awards, expanded, skillsData, progress, toggleExpand, toggleSkill } = useSkills(section);
  const award = awards[section];
  const emptyProgress = { completed: 0, total: award?.skills.length || 0, pct: 0 };

  return (
    <div className="space-y-6" data-testid="skills-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Progress tracker</div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Outfit" }}>Chief Scout Award Skills</h1>
        <p className="text-muted-foreground text-sm mt-1">Record each member's progress towards their section's top award.</p>
      </div>

      <Tabs value={section} onValueChange={setSection}>
        <TabsList className="flex flex-wrap h-auto gap-1">
          {SECTIONS.map((s) => <TabsTrigger key={s.value} value={s.value} data-testid={`skills-tab-${s.value}`}>{s.label}</TabsTrigger>)}
        </TabsList>
      </Tabs>

      <AwardBanner section={section} award={award} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {members.length === 0 && (
          <div className="col-span-full text-center py-10 text-muted-foreground" data-testid="skills-empty">No members in this section yet.</div>
        )}
        {members.map((m) => (
          <SkillMemberCard key={m.id} member={m} isOpen={expanded === m.id} skillsData={skillsData}
            progress={progress[m.id] || emptyProgress} onExpand={toggleExpand} onToggleSkill={toggleSkill} />
        ))}
      </div>
    </div>
  );
}
